// extracted by mini-css-extract-plugin
export default {"inputsContainer":"name-and-email-form_inputsContainer__o1q8w"};